var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0305 25.1359C28.655 27.4235 26.1717 28.8312 23.4946 28.8312C20.8175 28.8312 18.3435 27.4235 16.9588 25.1359C15.5833 22.839 15.491 19.9865 16.7372 17.6063C16.7557 17.5877 16.7557 17.5599 16.7834 17.5414L22.8854 8.52996C23.0146 8.32621 23.2361 8.20581 23.4762 8.20581C23.7162 8.20581 23.947 8.32621 24.0762 8.52996L30.1874 17.5414C30.1874 17.5414 30.2243 17.5877 30.2336 17.6063C31.4798 19.9865 31.3967 22.839 30.012 25.1359H30.0305Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0656 19.8474C5.65942 11.3731 11.2721 3.5286 19.7927 1.44476C29.458 -0.916925 39.1972 5.01971 41.5604 14.7165C43.9145 24.4133 37.9971 34.1842 28.3318 36.5552C23.2453 37.7962 18.1403 36.7404 14.0969 34.0546",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0507 15.8186L6.02881 20.9402L0.923828 15.902",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackdrop);
export default __webpack_public_path__ + "static/media/icon_backdrop.d953c3bcfca5e9301bd399e04c38d66a.svg";
export { ForwardRef as ReactComponent };